import React, { useEffect, useRef, useState } from "react";
import "./topBands.css";
import dashboardService from "services/dashboard.service";

interface MetalData {
  metal: string;
  inStock: boolean;
}

const MOBILE_MESSAGE =
  "Digital Silver purchases will be in Queue while we are out of stock. Your orders will be executed at the same rate when stock arrives.";

const WEB_MESSAGE =
  "Digital Silver purchases will be in Queue while we are out of stock. Once we replenish stock, your orders will be executed at the same rate. This is due to sudden surge in demand and shortage of Silver in the market.";

const TopBands: React.FC = () => {
  const [currentMessage, setCurrentMessage] = useState<string | null>(null);
  const [isActive, setIsActive] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  /** Decide message purely by screen size */
  const getMessageByScreen = () => {
    return window.innerWidth <= 768 ? MOBILE_MESSAGE : WEB_MESSAGE;
  };

  /** Fetch stock status */
  const fetchStockStatus = async () => {
    try {
      const response = await dashboardService.isStockAvailable();
      const data: MetalData[] = response?.data?.data || [];

      const silverData = data.find(
        (item) => item.metal.toLowerCase() === "silver"
      );

      // ✅ Show band ONLY when Silver is out of stock
      if (silverData && silverData.inStock === false) {
        setCurrentMessage(getMessageByScreen());
        setIsActive(true);
      } else {
        setCurrentMessage(null);
        setIsActive(false);
      }
    } catch (error) {
      console.error("Error fetching stock status:", error);
      setCurrentMessage(null);
      setIsActive(false);
    }
  };

  /** Initial fetch + polling */
  useEffect(() => {
    fetchStockStatus();
    const interval = setInterval(fetchStockStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  /** Update message on resize WITHOUT refetching API */
  useEffect(() => {
    const handleResize = () => {
      if (!isActive) return;
      setCurrentMessage(getMessageByScreen());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isActive]);

  return (
    <div className={`top-bands ${isActive ? "alert-active" : "alert-inactive"}`}>
      {currentMessage && (
        <div className="scrolling-wrapper">
          <div className="scrolling-container" ref={containerRef}>
            <div className="scrolling-message">
              <span>⚠️ {currentMessage}&nbsp;&nbsp;&nbsp;</span>
              <span>⚠️ {currentMessage}&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBands;
